export const workspaceApplicationCatalogCategories = [
  "platform",
  "web",
  "commerce",
  "sales",
  "finance",
  "people",
  "work",
  "operations",
  "services",
  "communication",
  "content",
  "engagement",
] as const;

export type WorkspaceApplicationCatalogCategory =
  (typeof workspaceApplicationCatalogCategories)[number];

export function isWorkspaceApplicationCatalogCategory(
  value: string,
): value is WorkspaceApplicationCatalogCategory {
  return workspaceApplicationCatalogCategories.some((category) => category === value);
}
